import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register the service worker for offline support (production + previews).
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { updateViaCache: "none" })
      .then((reg) => {
        // Actively check for a newer worker on every load so a stale one
        // (serving a blank shell) is replaced without any manual action.
        reg.update().catch(() => {});
      })
      .catch((err) => console.warn("SW registration failed:", err));
  });
}
